// extracted by mini-css-extract-plugin
module.exports =  {"info":"info__-XprD","sub":"sub__u989-","fullScreenModal":"fullScreenModal__06TOV","addNewProductBtn":"addNewProductBtn__QDOhX","productNameTitle":"productNameTitle__XvMmn"};